import { sendGAEvent } from "@next/third-parties/google";
import { forwardGtagEvent } from "@/lib/visitorTracker";

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID;

const isProductionBrowser =
    process.env.NODE_ENV === "production" &&
    typeof window !== "undefined" &&
    Boolean(GA_MEASUREMENT_ID);

export function trackPageView(url) {
    if (!isProductionBrowser || !url) {
        return;
    }

    sendGAEvent("event", "page_view", {
        page_location: window.location.origin + url,
        page_path: url,
        page_title: document.title,
    });
}

export function trackEvent(eventName, params = {}) {
    // Key events also go to our own visitor journey (all environments).
    forwardGtagEvent(eventName, params);

    if (!isProductionBrowser || !eventName) {
        return;
    }

    sendGAEvent("event", eventName, params);
}

export function trackButtonClick(buttonName, params = {}) {
    trackEvent("button_click", {
        button_name: buttonName,
        ...params,
    });
}

export function trackBooking(params = {}) {
    trackEvent("book_appointment", params);
}

export function trackSignup(params = {}) {
    trackEvent("sign_up", params);
}

export function trackLogin(params = {}) {
    trackEvent("login", params);
}

export function trackPaymentSuccess(params = {}) {
    trackEvent("payment_success", params);
}

export function trackOnboardingComplete(params = {}) {
    trackEvent("tutorial_complete", params);
}

export function trackLead(params = {}) {
    trackEvent("generate_lead", params);
}

export function trackAddPaymentMethod(params = {}) {
    trackEvent("add_payment_info", params);
}

export function trackInvoicePaymentSuccess(params = {}) {
    trackEvent("invoice_payment_success", params);
}

export function trackSubscriptionPurchase(params = {}) {
    trackEvent("subscription_purchase", params);
}
